export default {
  INIT: 'RICECOIN/INIT',
  UPDATE_DATA: 'RICECOIN/UPDATE_DATA',
  UPDATE_META: 'RICECOIN/UPDATE_META',
  UPDATE_PARAMS: 'RICECOIN/UPDATE_PARAMS',
}
